// Replace escaped <br> tags in breadcrumb with dash
;(function () {
	'use strict'

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', replaceBreadcrumbBreaks)
	} else {
		replaceBreadcrumbBreaks()
	}

	function replaceBreadcrumbBreaks() {
		const breadcrumbs = document.querySelectorAll('.pdms-client')

		breadcrumbs.forEach(subs => {
			// Skip if this is inside section--breadcrumb
			if (subs.closest('.section--breadcrumb')) return

			const elements = subs.querySelectorAll('h1,h2,h3,h4,h5,p,a,span')

			elements.forEach(el => {
				// Skip img tags - don't modify title attributes
				if (el.tagName === 'IMG') return

				// Skip if element is inside breadcrumb section
				if (el.closest('.section--breadcrumb')) return

				// Skip if this element contains other text elements (avoid nesting issues)
				const hasNestedTextElements = el.querySelector('h1,h2,h3,h4,h5,p,a,span')
				if (hasNestedTextElements) return

				let html = el.innerHTML
				html = html.replace(/\|\s*/g, '<br>')
				el.innerHTML = html
			})
		})
	}
})()
